import Project from '@theme/global-functions';

export default class Autocomplete {
  constructor(parent) {
    this.parent = parent;
    this.autocompleteWrapper = parent.element.querySelector(
      '.search-block__autocomplete-results'
    );
    this.loader = parent.element.querySelector('.search-block__spinner');
    this.noSearchResults = parent.element.querySelector(
      '.search-block__no-results'
    );
    this.list = document.createDocumentFragment();
  }

  get isActive() {
    return this.parent.inputField.value.length > 2;
  }

  registerEffects() {
    this.parent.inputField.addEventListener(
      'input',
      Project.debounce(this.updateSearchResults.bind(this), 350)
    );
  }

  async updateSearchResults(e) {
    this.autocompleteWrapper.innerHTML = '';

    if (e.target.value.length < 3) {
      return;
    }

    this.parent.changeState('loader');

    try {
      const response = await fetch(
        `/wp-json/wp/v2/search/?search=${e.target.value}&_fields=title,url`
      );

      const searchResults = await response.json();

      searchResults.forEach((result) => {
        const resultWrapper = document.createElement('div');
        const resultElement = document.createElement('a');

        resultElement.innerHTML = result.title.replace(
          new RegExp(e.target.value, 'gi'),
          '<strong>$&</strong>'
        );
        resultElement.setAttribute('href', result.url);
        resultWrapper.appendChild(resultElement);

        this.list.appendChild(resultWrapper);
      });

      this.showResults();
    } catch (error) {
      console.error(error);
    }
  }

  showResults() {
    this.parent.changeState('autocomplete');

    if (this.list.childElementCount === 0) {
      this.parent.changeState('no-results');
      return;
    }

    this.autocompleteWrapper.appendChild(this.list);
  }
}
